import { use, useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Cuboid, ChevronRight } from "lucide-react";

const Header = () => {
	const [storedData, setStoredData] = useState<string | null>(null);

	useEffect(() => {
		const data = localStorage.getItem("walletData");
		setStoredData(data);
	}, []);

	return (
		<header className="flex items-center justify-between px-8 py-6 border-b border-neutral-900">
			<div className="flex items-center gap-3">
				<div className="flex items-center justify-center h-10 w-10 rounded-xl bg-neutral-900 border border-neutral-800">
					<Cuboid className="h-5 w-5 text-neutral-50" />
				</div>
				<span className="font-bold text-xl tracking-tight text-white">Flux</span>
				<span className="text-xs px-3 py-1 rounded-full bg-neutral-900 text-neutral-400 border border-neutral-800">
					v1
				</span>
			</div>

			{storedData && (
				<Button
					onClick={() => (window.location.href = "/dashboard")}
					variant="ghost"
					className="text-neutral-900 bg-neutral-50"
				>
					Dashboard
					<ChevronRight className="h-4 w-4 mr-1" />
				</Button>
			)}
		</header>
	);
};

export default Header;
